<app-header></app-header>
<app-home></app-home>
<app-footer></app-footer>

<router-outlet></router-outlet> 
